import { useContext, useMemo } from "react";

import { userDetailContext } from "../App";
import { SMQ_PRIVILEGES } from "../constants/smqPrivileges";
import { hasPrivilege } from "../utils/privilege";

/**
 * Hook to check SMQ permissions for the current user.
 * @returns {Object} An object containing the user's SMQ permissions.
 */
const useSmqPermissions = () => {
  const contextData = useContext(userDetailContext);

  return useMemo(() => {
    const privileges = contextData?.privileges || [];
    const canRead = hasPrivilege(privileges, SMQ_PRIVILEGES.READ);
    const isAdmin =
      canRead && hasPrivilege(privileges, SMQ_PRIVILEGES.ADMIN);
    const canValidate =
      canRead &&
      (isAdmin || hasPrivilege(privileges, SMQ_PRIVILEGES.VALIDATE));

    return {
      canRead,
      canCreate:
        canRead &&
        (isAdmin || hasPrivilege(privileges, SMQ_PRIVILEGES.CREATE)),
      canTreat:
        canRead &&
        (isAdmin || hasPrivilege(privileges, SMQ_PRIVILEGES.TREAT)),
      canValidate,
      isAdmin,
      isProcessScoped:
        canRead &&
        !canValidate &&
        !isAdmin &&
        hasPrivilege(privileges, SMQ_PRIVILEGES.PROCESS_SCOPE),
    };
  }, [contextData?.privileges]);
};

export default useSmqPermissions;
